<template>
  <div ref="video"></div>
</template>

<script>
import lottie from "lottie-web";
export default {
  props: ["content", "config"],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setLottie();
    });
  },
  methods: {
    setLottie() {
      this.animation = lottie.loadAnimation({
        container: this.$refs.video,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: `${this.baseUrl}${this.content}`,
        rendererSettings: {
          className: "tva-bodymovin"
        }
      });
    }
  }
};
</script>

<style lang="scss">
.tva-bodymovin {
  // width: inherit !important;
  // height: inherit !important;
  // bottom: inherit;
  // position: absolute;
  // left: 0;
  width: 100%;
  pointer-events: none;
}
</style>
